import React from 'react'

export default function ErrorText({children}) {
  return (
    <div className='text-error'>{children}</div>
  )
}
